<template>
  <div style="margin:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Bookings & Actuals</span><br/>
      <span style="font-style: italic; font-size: 18px">actuals scheduled to finish on selected date, click '+' for more details</span>
    </div>


    <div v-if="!this.$route.query.booking_id" style="font-size: 22px; font-weight: bold; position: relative; margin: 20px 0px 20px 0px" class="d-flex align-items-center justify-content-center">
      <a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"/>
      &nbsp;to&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_toDate" :config="options" :placeholder="details_toDate"/>
      &nbsp;<a href="#" class="white-link" v-on:click.prevent="shift_detail_graph_date(1)">></a>
      &nbsp;&nbsp;<b-form-select v-model="actuals_filter" :options="actuals_filter_options" style="font-size: 20px; font-weight: bold; width:190px"/>
      <span v-if="base_options && base_options.length > 2">
        &nbsp;&nbsp;<b-form-select v-model="selected_base" :options="base_options" style="font-size: 18px; font-weight: bold; width:200px"/>
      </span>
      &nbsp;&nbsp;<b-button v-on:click.prevent="search_by_date_range()">Search</b-button>
      &nbsp;&nbsp;&nbsp;By ID&nbsp;<b-form-input style="width: 150px" v-model="booking_search" placeholder="bookingID"/>&nbsp;<b-button v-on:click.prevent="search_by_id()">Search</b-button>
      &nbsp;&nbsp;&nbsp;Filter&nbsp;<b-form-input style="width: 150px" v-model="booking_filter" placeholder=""/>
      <span style="margin-left: 10px"><b-button size="md" v-on:click.prevent="reprocess_actuals()">Reprocess</b-button></span>
    </div>

    <div v-if="!this.$route.query.booking_id && !loading">
      <div class="row" style="margin: 30px; font-weight: bold; font-size: 22px;">
        <div @click="filter_by_status(null)" class="col" style="border: 1px solid grey;">{{items.length}} of {{items_full.length}}</div>
        <div @click="filter_by_status('success')" class="col success" :style="selected_status=='success' ? 'border: 2px solid red;' : 'border: 2px solid grey;'">Success: {{success_cnt}}</div>
        <div @click="filter_by_status('error')" class="col error" :style="selected_status=='error' ? 'border: 2px solid red;' : 'border: 2px solid grey;'">Errors: {{error_cnt}}</div>
        <div @click="filter_by_status('cancelled')" class="col cancelled" :style="selected_status=='cancelled' ? 'border: 2px solid red;' : 'border: 2px solid grey;'">Cancelled: {{cancelled_cnt}}</div>
        <div @click="filter_by_status('unprocessed')" class="col unprocessed" :style="selected_status=='unprocessed' ? 'border: 2px solid red;' : 'border: 2px solid grey;'">Pending: {{unprocessed_cnt}}</div>
        <div @click="filter_by_status('skipped')" class="col skipped" :style="selected_status=='skipped' ? 'border: 2px solid red;' : 'border: 2px solid grey;'">Skipped: {{skipped_cnt}}</div>
        <div v-if="calc_total_duration" class="col" style="border: 1px solid grey;">Hrs: {{calc_total_duration}}</div>
        <div v-if="calc_total_miles" class="col" style="border: 1px solid grey;">Miles: {{calc_total_miles}}</div>
        <div v-if="calc_total_odo_miles" class="col" style="border: 1px solid grey;">Odo: {{calc_total_odo_miles}}</div>
        </div>
    </div>

      <b-table :busy="loading" sticky-header="70vh" striped bordered :items="items" :fields="fields"
               :current-page="currentPage" :tbody-tr-class="get_row_color"
               :per-page="perPage">

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
          </div>
        </template>
        
        <template slot="status_msg" slot-scope="row">
          <div style="text-align: left" v-for="msg in row.item.status_msg.split(',')">
            <span v-html="msg"/>
          </div>
        </template>

        <template slot="bookingID" slot-scope="row">
          {{row.item.bookingID}}
        </template>

        <template slot="vehicleAssignmentID" slot-scope="row">
          {{row.item.vehicleAssignmentID}}
        </template>

        <template slot="dispatchID" slot-scope="row">
          {{row.item.dispatchID}}
        </template>

        <template slot="driver" slot-scope="row">
          {{row.item.driver}}
        </template>

        <template slot="day_of_trip" slot-scope="row">
          <span v-if="row.item.final_day_of_trip">{{row.item.day_of_trip}} of {{row.item.final_day_of_trip}}</span>
          <span v-else>{{row.item.day_of_trip}}</span>
        </template>

        <template slot="last_updated" slot-scope="row">
          {{row.item.last_updated | formatDateTimeSmall}}
        </template>

        <template slot="startBase" slot-scope="row">
          {{row.item.startBase | trim(30)}}
        </template>

        <template slot="finishBase" slot-scope="row">
          {{row.item.finishBase | trim(30)}}
        </template>

        <template slot="vehicle" slot-scope="row">
          <a target="_blank" :href="row.item.samsara_vehicle_link">{{row.item.vehicle}}</a>
        </template>

        <template slot="processed_time" slot-scope="row">
          {{row.item.processed_time | formatDateTimeSmall}}
        </template>

        <template slot="start_datetime" slot-scope="row">
          {{row.item.start_datetime | formatDateTimeSmall}}
        </template>
        
        <template slot="finish_datetime" slot-scope="row">
          {{row.item.finish_datetime | formatDateTimeSmall}}
        </template>

        <template slot="driver_start_date" slot-scope="row">
          <span v-if="row.item.day_of_trip == 1">
            {{row.item.driver_start_date | formatDateTimeSmall}}
          </span>
          <span v-else></span>
        </template>

        <template slot="driver_finish_date" slot-scope="row">
          <span v-if="row.item.day_of_trip == row.item.final_day_of_trip">
            {{row.item.driver_finish_date | formatDateTimeSmall}}
          </span>
          <span v-else></span>
        </template>

        <template slot="routeDescription" slot-scope="row">
          {{row.item.routeDescription | trim(30)}}
        </template>

        <template slot="details" slot-scope="row">
          <div style="align-content: center">
            <b-button size="sm" @click="row.toggleDetails">
              {{ row.detailsShowing ? '-' : '+' }}
            </b-button>&nbsp;
          </div>
        </template>

        <template slot="row-details" slot-scope="row">

          <div style="text-align: left; padding: 10px; margin:10px; border: 1px dotted grey">

            <h5>Vehicle Segments: {{row.item.vehicleAssignment.RouteDescription}}</h5>
            <table width="100%" cellpadding="5" cellspacing="5" >
              <tr>
                <th>Departure</th>
                <th>Planned Departure</th>
                <th>Actual Departure</th>
                <th>Diff</th>
                <th>Arrival</th>
                <th>Planned Arrival</th>
                <th>Actual Arrival</th>
                <th>Diff</th>
              </tr>
              <tr v-for="segment in row.item.vehicleAssignment.VehicleSegments">
                  <td style="text-align: left !important;"><a target='_blank' :href="'https://www.google.com/maps/search/?api=1&query=' + segment.departureLatitude + ',' + segment.departureLongitude">{{segment.departureAddress | trim(50)}}</a></td>
                  <td>{{segment.departureTime | formatDateTime}}</td>
                  <td>{{segment.actualDepartureTime | formatDateTime}}</td>
                  <td>{{get_time_diff(segment.departureTime,segment.actualDepartureTime)}}</td>
                  <td style="text-align: left !important"><a target='_blank' :href="'https://www.google.com/maps/search/?api=1&query=' + segment.arrivalLatitude + ',' + segment.arrivalLongitude">{{segment.arrivalAddress | trim(50)}}</a></td>
                  <td>{{segment.arrivalTime | formatDateTime}}</td>
                  <td>{{segment.actualArrivalTime | formatDateTime}}</td>
                  <td>{{get_time_diff(segment.arrivalTime,segment.actualArrivalTime)}}</td>
              </tr>
            </table>

            <br/>
            <div v-html="row.item.actual.samsara_links"/>
            <span>
              <b>Map Links: </b>
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/vehicle-track/' + user.tenant + '/' + row.item.vehicle }">Track Vehicle</router-link>
              &nbsp;|&nbsp;
              <router-link style="font-weight: bold;" :to="{ path: '/vehicle_trip_history?vehicleId=' + row.item.vehicle + '&trip_date=' + row.item.start_datetime.split('T')[0] }">Trip History</router-link>
              &nbsp;|&nbsp;
              <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/booking/' + row.item.bookingID + '/tbn'}">Map By Booking ID</router-link>
              <span v-if="row.item.type == 'scheduledservice'">
                &nbsp;|&nbsp;
                <router-link target="_blank" style="font-weight: bold;" :to="{ path: '/fleet-track/' + user.tenant + '/bookingType/' + row.item.bookingID.split('-')[0] + '/tbn'}">Line Run Map</router-link>
              </span>
            </span>

            <div class="row" style="margin: 0px">
              <div class="col" v-if="row.item.actual">
                <b>Start Event Times:</b><br/>
                Planned Driver Start: {{row.item.driver_start_date | formatDateTimeSmall}}<br/>
                HOS On Duty: {{row.item.actual.actualClockInTime | formatDateTime}}<br/>
                DVIR Pre Trip Time: {{row.item.actual.nearestPreTripDVIRDateTime | formatDateTime}}<br/>
                Vehicle Key On: {{row.item.actual.actualIgnitionOnTime | formatDateTime}}<br/>
                Vehicle Leave Time: {{row.item.actual.actualStartLocationTime | formatDateTime}}<br/>
                First Pickup Time: {{row.item.actual.actualFirstPickupTime | formatDateTime}}<br/>
                Trip Start Time: {{row.item.actual.actualStartTripTime | formatDateTime}}
              </div>

              <div class="col" v-if="row.item.actual">
                <b>Finish Event Times:</b><br/>
                Planned Driver Finish: {{row.item.driver_finish_date | formatDateTimeSmall}}<br/>
                HOS Off Duty: {{row.item.actual.actualClockOutTime | formatDateTime}}<br/>
                DVIR Post Trip Time: {{row.item.actual.nearestPostTripDVIRDateTime | formatDateTime}}<br/>
                Vehicle Key Off: {{row.item.actual.actualIgnitionOffTime | formatDateTime}}<br/>
                Vehicle Back Time: {{row.item.actual.actualFinishLocationTime | formatDateTime}}<br/>
                Last DropOff Time: {{row.item.actual.actualLastDropOffTime | formatDateTime}}<br/>
                Trip Finish Time: {{row.item.actual.actualFinishTripTime | formatDateTime}}
              </div>

              <div class="col" v-if="row.item.actual">
                <b>Trip Duration (minutes)</b><br/>
                Total Duration: {{row.item.actual.actualTotalDuration}}<br/>
                Driving Duration: {{row.item.actual.actualDrivingDuration}}<br/>
                Wait Duration: {{row.item.actual.actualWaitDuration}}<br/>
                Live Duration: {{row.item.actual.actualLiveDuration}}<br/>
                Dead Duration: {{row.item.actual.actualDeadDuration}}<br/>
              </div>

              <div class="col" v-if="row.item.actual">
                <b>Distances (miles)</b><br/>
                Total Trip Distance: {{row.item.actual.actualTotalDistance}}<br/>
                Start Odometer: {{row.item.actual.actualStartOdometer}}<br/>
                First Pickup Odometer: {{row.item.actual.actualFirstPickupOdometer}}<br/>
                Last Dropoff Odometer: {{row.item.actual.actualLastDropOffOdometer}}<br/>
                End Odometer: {{row.item.actual.actualEndOdometer}}<br/>
                <span v-if="row.item.actual.actualEndOdometer && row.item.actual.actualStartOdometer">
                  Total Odometer Distance: {{row.item.actual.actualEndOdometer - row.item.actual.actualStartOdometer}}
                </span>
              </div>

              <div class="col" v-if="row.item.actual">
                <b>State Distances (miles)</b><br/>
                <div v-for="dist in row.item.actual.actualDistances">
                  {{dist.jurisdiction}} : {{dist.distance}}
                </div>
              </div>
            </div>

            <div v-if="row.item.vehicleAssignment" style="text-align: left; margin: 10px">
              <button @click="toggle_div(row.item.actual,'isAssignmentVisible')">show assignment</button>
              <br/>
              <span :style="row.item.actual.isAssignmentVisible ? '' : 'display:none'">
                <pre style="text-align: left">{{row.item.vehicleAssignment | prettyJsonObj}}</pre>
              </span>
            </div>

            <div v-if="row.item.actual.json" style="text-align: left; margin: 10px">
              <button @click="toggle_div(row.item.actual,'isActualJsonVisible')">show actual results</button>
              <br/>
              <span :style="row.item.actual.isActualJsonVisible ? '' : 'display:none'">
                <pre style="text-align: left">{{row.item.actual.json | prettyJsonObj}}</pre>
              </span>
            </div>

            <div v-if="row.item.booking_history" style="text-align: left; margin: 10px">
              <button @click="toggle_div(row.item.actual,'isHistoryVisible')">show booking update history</button>
              <br/>
              <span :style="row.item.actual.isHistoryVisible ? '' : 'display:none'">

                  <div class="row" style="margin:5px" v-for="booking_processed_time in row.item.booking_history.split(',')">
                    <div style="max-width: 250px" class="col">{{booking_processed_time | formatDateTime}}</div>
                    <div class="col">
                      <a href="#" v-on:click.prevent="show_booking_history(booking_processed_time)">show/hide booking</a>
                      <span v-if="booking_processed_time in booking_history_json">
                        <br/><hr/>
                        <b>Differences</b><br/><hr/>
                        {{booking_history_json[booking_processed_time].payload_diff}}
                      </span>
                      <span v-if="booking_processed_time in booking_history_json">
                        <br/><hr/>
                        <b>Full Booking</b><br/><hr/>
                        <pre>{{booking_history_json[booking_processed_time].payload}}</pre>
                      </span>
                    </div>
                  </div>
              </span>
            </div>

          </div>
        </template>
      </b-table>
      <b-row>
        <b-col>
          <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
          >
          </b-pagination>
        </b-col>
      </b-row>
    </div>
</template>

<script>

import {api_url, get_tbn_booking_history, get_tbn_actuals, reprocess_actuals} from '../networking/tbn_apis'
    import {mapState} from "vuex";
    import moment from 'moment'
    import {justDate} from "@/helpers/dates";
    import axios from 'axios';

    export default {
      name: 'actuals_tbn',
      components: {
      },

      data() {
        return {
          items: [],
          items_full: [],
          selected_status: null,
          summary: [],
          loading: true,
          base_options: [],
          selected_base: '',
          details_fromDate: justDate(moment()),
          details_toDate: justDate(moment()),
          totalRows: 1,
          currentPage: 1,
          perPage: 100,
          pages: [],
          actuals_filter: 'finish',
          booking_filter: '',
          booking_search: '',
          booking_history_json: {},
          actuals_filter_options: [
            { value: 'finish', text: 'By Finish Date' },
            { value: 'start', text: 'By Start Date' },
            { value: 'overlap', text: 'Overlaps Range' },
          ],
          fields: [
            { key: 'details', label: '', sortable: false},
            { key: 'ID', label: 'ID', sortable: true},
            { key: 'bookingID', sortable: true},
            //{ key: 'bookingStatus', label: 'Booking Status', sortable: true},
            //{ key: 'vehicleAssignmentStatus', label: 'Assign Status', sortable: true},
            { key: 'vehicleAssignmentID', label:'AssignID', sortable: true},
            { key: 'dispatchID', label:'DispatchID', sortable: true},
            { key: 'routeDescription', label:'Route', sortable: true, thStyle: { width: "200px" }},
            { key: 'vehicle', label:'VehicleID', sortable: true},
            { key: 'driver', sortable: true, label: 'Driver', thStyle: { width: "140px" }},
            { key: 'startBase', sortable: true, label: 'Start Base', thStyle: { width: "140px" }},
            { key: 'finishBase', sortable: true, label: 'Finish Base', thStyle: { width: "140px" }},
            { key: 'day_of_trip', label: 'Trip Day', sortable: true},
            { key: 'driver_start_date', label:'Driver Start', sortable: true},
            { key: 'start_datetime', label:'First Departure', sortable: true},
            { key: 'finish_datetime', label: 'Last Arrival', sortable: true},
            { key: 'driver_finish_date', label:'Driver Finish', sortable: true},
            { key: 'status', sortable: true},
            { key: 'status_msg', label: 'Status Message', sortable: true, thStyle: { width: "350px" }},
          ]
          ,
          options: {
            format: 'MM-DD-YYYY',
            useCurrent: true,
            minDate: moment().subtract(400, 'days'),
            maxDate: moment().add(180, 'days'),
            keepOpen: false,
            showClear: true,
            showClose: true,
            toolbarPlacement: 'top',
          },

        }
      },

      async created() {
        this.fields_all = this.fields
        this.check_features()
      },
      methods: {
        async check_features() {
          let admin_view = this.user.role == 'admin'
          this.fields = this.fields_all
          if (!admin_view)
            this.fields = this.fields.filter(item => (item.key != 'ID' && item.key != 'vehicleAssignmentID' && item.key != 'dispatchID') )
          this.load_data()
        },
        async search_by_date_range() {
          this.booking_search = ''
          this.load_data()
        },
        async search_by_id() {
          this.load_data()
        },
        async load_data() {
            this.loading = true
            try {
              if (this.$route.query.booking_id)
                this.booking_search = this.$route.query.booking_id

              const {value: {data = []}} = await get_tbn_actuals(this.user.tenant, this.actuals_filter, this.booking_search, this.selected_base, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
              this.summary = data.summary
              moment.tz.setDefault(this.summary.timezone)
              this.items = data.results
              this.items_full = data.results
              if (this.base_options.length === 0)
                this.base_options = data.summary.bases
              this.filter_results()
            } catch(e) {
              this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
            }
            this.loading = false
        },
        async reprocess_actuals() {
          try {
            if (this.items_full.length > 200) {
              alert("please limit actuals reprocessing to 200 bookings or less or contact support if needed")
              return
            }

            if (confirm("are you sure you want to reprocess actuals for this date range? (note - this is only necessary if HOS edits were made)")) {
              this.$emit('showAlert', 'sending request to reprocess actuals', 'info', 5000)
              const {value: {data = []}} = await reprocess_actuals(this.user.tenant, this.actuals_filter, this.selected_base, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'), moment(this.details_toDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
              this.$emit('showAlert', 'reprocess request sent', 'success', 5000)
            }
          } catch(e) {
            this.$emit('showAlert', 'error reprocessing actuals, try a smaller date range or contact support if needed', 'danger', 5000)
          }
        },
        async show_booking_history(processed_time) {
          if (this.booking_history_json[processed_time])
            delete this.booking_history_json[processed_time]
          else {
            const {value: {data = []}} = await get_tbn_booking_history(this.user.tenant, processed_time)
            this.booking_history_json[processed_time] = data
          }
          this.$forceUpdate()
        },
        async download(){
          this.$emit('showAlert', 'processing download request', 'info', 5000)
          axios.defaults.headers.common.Accept = {}
          axios.post(
              `${api_url}tbn/actuals/download`,
              {
                tenant: this.user.tenant,
                date: moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'),
              }, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                  Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                responseType: 'blob'
              }
          ).then((response) => {
            axios.defaults.headers.common.Accept = 'application/json'
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute(
                'download',
                `actuals-${this.user.tenant}-${this.details_fromDate}.csv`
            )
            document.body.appendChild(link)
            link.click()
            this.$emit('showAlert', 'download complete', 'success', 5000)
          }).catch(e => {
            axios.defaults.headers.common.Accept = 'application/json'
            this.$emit('showAlert', 'actuals data could not be downloaded.', 'danger')
          })
        },
        async shift_detail_graph_date(shift) {
          this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
          this.details_toDate = moment(this.details_toDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
          this.booking_id_filter = ''
        },
        get_time_diff(time1, time2) {
          if (time1 != null && time2 != null)
            return Math.round((new Date(time2) - new Date(time1)) / (1000 * 60)) + 'm';
          return ''
        },
        toggle_div(item,field) {
          item[field] = !item[field];
          this.$forceUpdate();
        },
        get_row_color(item, type) {
            if (!item || type !== 'row') return
            return item.status
        },
        filter_by_status(status) {
          if (status == null || this.selected_status == status) {
            this.selected_status = null
          } else {
            this.selected_status = status
          }
          this.filter_results()
        },
        filter_results() {
          this.items = this.items_full
          if (!this.items)
            return
          const val = this.booking_filter
          if (val != '')

            if (this.booking_filter.indexOf("=") != -1) {
              const field = this.booking_filter.split("=")[0]
              const value = this.booking_filter.split("=")[1]
              if (field == 'driver')
                this.items = this.items.filter(item => item.driver == value)
              else if (field == 'vehicle')
                this.items = this.items.filter(item => item.vehicle ==value)
            } else {
              this.items = this.items.filter(item => this.contains(item.ID, val) || this.contains(item.routeDescription, val) || this.contains(item.status_msg, val) || this.contains(item.driver, val) || this.contains(item.vehicle, val))
            }
          if (this.selected_status != null)
            this.items = this.items.filter(item => item.status == this.selected_status)
          if (this.selected_base != '') {
            this.items = this.items.filter(item => item.startBase.indexOf(this.selected_base) != -1)
          }
        },
        contains(val1, val2) {
          if (val1 != null) {
            return val1.toLowerCase().indexOf(val2.toLowerCase()) != -1;
          }
          return false;
        },
      },
      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
        calc_total_duration() {
          let total_minutes = this.items.reduce((accumulator, current) => accumulator + current.total_duration, 0);
          if (total_minutes > 0) {
            let total_hours = total_minutes / 60;
            return total_hours.toFixed(2)
          }
          return null;
        },
        success_cnt() {
          return this.items_full.filter(item => item.status=='success').length
        },
        error_cnt() {
          return this.items_full.filter(item => item.status=='error').length
        },
        cancelled_cnt() {
          return this.items_full.filter(item => item.status=='cancelled').length
        },
        unprocessed_cnt() {
          return this.items_full.filter(item => item.status=='unprocessed').length
        },
        skipped_cnt() {
          return this.items_full.filter(item => item.status=='skipped').length
        },
        calc_total_miles() {
          return this.items.reduce((accumulator, current) => accumulator + current.total_miles, 0);
        },
        calc_total_odo_miles() {
          return this.items.reduce((accumulator, current) => accumulator + current.total_odo_miles, 0);
        },
      },
      watch: {
        user: {
          deep: true,
          handler() {
            this.load_data()
          }
        },
        selected_base() {
          this.filter_results()
        },
        booking_filter() {
          this.filter_results()
        }
      }
    }
</script>

<style>

.error { background-color: rgba(255,0,0,0.25)}
.success { background-color: hsla(120,100%,75%,0.3)}
.unprocessed { background-color: hsla(200,40%,80%,0.3) }
.skipped { background-color: hsla(190,90%,80%,0.3) }
.cancelled { background-color: hsla(290,60%,70%,0.3) }

.error td { background-color: rgba(255,0,0,0.25)}
.success td {background-color: hsla(120,100%,75%,0.3)}
.unprocessed td { background-color: hsla(200,40%,80%,0.3) }
.skipped td { background-color: hsla(190,90%,80%,0.3) }
.cancelled td { background-color: hsla(290,60%,70%,0.3) }


div.row:nth-child(even) {
  background-color: #f2f2f2;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

.header {
  font-weight: bold;
}

div.col {
  border: 1px solid grey;
}

.table td {
  padding: .1rem !important;
}

.mvmt-table td {
  vertical-align: middle !important;
}

</style>

